import { PRIVACY_DOC, TERMS_DOC } from "./legalDocs";

const LEGAL_PATHS = [PRIVACY_DOC.path, TERMS_DOC.path];

/**
 * The app uses a hash router, so the public legal links (email footer, SQL) written as
 * `/aviso-privacidad` would be read as `/` (login or "Mi día"). Returns the hash URL to
 * show instead, or null when the current URL is not a bare legal path.
 */
export const legalPathToHash = (
  pathname: string,
  hash: string,
): string | null => {
  const path = pathname.replace(/\/+$/, "");
  if (hash || !LEGAL_PATHS.includes(path)) return null;
  return `/#${path}`;
};
